import { store } from 'base/store'

export class AuthenticationService {

  static get isAuthenticated(): boolean {
    return !!localStorage.getItem('ls.jwt')
  }

  static get accesskey(): string | undefined {
    if (!store.state.user) return
    return store.state.user.accesskey
  }

  static get jsonWebToken(): string | undefined {
    return store.state.jwt
  }
}
